
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ComItemFlagCompo extends Vue {
  @Prop({ default: () => {}, type: Object })
  itemData;
  @Prop({ default: false, type: Boolean })
  hoverShowNumber: boolean;
}
